var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"c-simple-btn",class:[_vm.btnType, _vm.dense ? 'u-btn-dense' : ''],attrs:{"depressed":""},on:{"click":_vm.clickHandler}},[_vm._t("default"),_c('span',{staticClass:"c-simple-btn__title"},[_vm._v(_vm._s(_vm.label))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }